/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AddressDto } from './address-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryWithChallengeDto } from './challenge-category-with-challenge-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { DeliveryDto } from './delivery-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ParticipationEntitlementDto } from './participation-entitlement-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface GetParticipationByIdResponseDto
 */
export interface GetParticipationByIdResponseDto {
    /**
     * Participation ID
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'id': string;
    /**
     * Challenge category ID
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'challengeCategoryId': string;
    /**
     * User ID
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'userId': string;
    /**
     * Delivery address ID for finisher items (optional for digital-only challenges)
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'deliveryAddressId'?: string;
    /**
     * Total distance covered by the user in this challenge category in meters
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'totalDistanceCovered': number;
    /**
     * Finisher shirt size selected by the user
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'finisherShirtSize': string;
    /**
     * Participation status
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'status': GetParticipationByIdResponseDtoStatusEnum;
    /**
     * Payment status
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'paymentStatus': GetParticipationByIdResponseDtoPaymentStatusEnum;
    /**
     * Payment amount in the local currency
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'paymentAmount': number;
    /**
     * Price type for this participation
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'priceType': GetParticipationByIdResponseDtoPriceTypeEnum;
    /**
     * Electronic bib number assigned to the participant
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'eBibNumber'?: string;
    /**
     * URL of the electronic bib number image
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'eBibNumberImageUrl'?: string;
    /**
     * URL of the electronic certificate image
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'eCertificateImageUrl'?: string;
    /**
     * Whether participant chose to include finisher shirt
     * @type {boolean}
     * @memberof GetParticipationByIdResponseDto
     */
    'shouldIncludeFinisherShirt': boolean;
    /**
     * Whether participant chose to include medal
     * @type {boolean}
     * @memberof GetParticipationByIdResponseDto
     */
    'shouldIncludeMedal': boolean;
    /**
     * Payment amount for finisher shirt when optional
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'finisherShirtPaymentAmount': number;
    /**
     * Payment amount for medal when optional
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'medalPaymentAmount': number;
    /**
     * Payment processing fee amount
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'paymentProcessingFeeAmount': number;
    /**
     * Delivery fee amount
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'deliveryFeeAmount': number;
    /**
     * Custom entitlements selected for this participation
     * @type {Array<ParticipationEntitlementDto>}
     * @memberof GetParticipationByIdResponseDto
     */
    'participationEntitlements'?: Array<ParticipationEntitlementDto>;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'updatedAt': string;
    /**
     * Challenge category details
     * @type {ChallengeCategoryWithChallengeDto}
     * @memberof GetParticipationByIdResponseDto
     */
    'challengeCategory': ChallengeCategoryWithChallengeDto;
    /**
     * Challenge status
     * @type {string}
     * @memberof GetParticipationByIdResponseDto
     */
    'challengeStatus': GetParticipationByIdResponseDtoChallengeStatusEnum;
    /**
     * Progress percentage
     * @type {number}
     * @memberof GetParticipationByIdResponseDto
     */
    'progressPercentage': number;
    /**
     * Challenge category details
     * @type {AddressDto}
     * @memberof GetParticipationByIdResponseDto
     */
    'deliveryAddress': AddressDto;
    /**
     * Delivery details for this participation
     * @type {DeliveryDto}
     * @memberof GetParticipationByIdResponseDto
     */
    'delivery'?: DeliveryDto;
    /**
     * User details
     * @type {UserDto}
     * @memberof GetParticipationByIdResponseDto
     */
    'user': UserDto;
}

export const GetParticipationByIdResponseDtoStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type GetParticipationByIdResponseDtoStatusEnum = typeof GetParticipationByIdResponseDtoStatusEnum[keyof typeof GetParticipationByIdResponseDtoStatusEnum];
export const GetParticipationByIdResponseDtoPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type GetParticipationByIdResponseDtoPaymentStatusEnum = typeof GetParticipationByIdResponseDtoPaymentStatusEnum[keyof typeof GetParticipationByIdResponseDtoPaymentStatusEnum];
export const GetParticipationByIdResponseDtoPriceTypeEnum = {
    Regular: 'regular',
    EarlyBird: 'early_bird',
    Free: 'free'
} as const;

export type GetParticipationByIdResponseDtoPriceTypeEnum = typeof GetParticipationByIdResponseDtoPriceTypeEnum[keyof typeof GetParticipationByIdResponseDtoPriceTypeEnum];
export const GetParticipationByIdResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type GetParticipationByIdResponseDtoChallengeStatusEnum = typeof GetParticipationByIdResponseDtoChallengeStatusEnum[keyof typeof GetParticipationByIdResponseDtoChallengeStatusEnum];


